<template>
    <div v-show="visible">
        <el-dialog title="修改" :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="450px">    
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item   prop="schoolId" label="关联上级区县" >

                    <el-select v-model="form.schoolId" style="width:280px;" collapse-tags clearable
                        placeholder="请选择学区">
                        <el-option
                            v-for="item in depts"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>

                </el-form-item>

                <el-form-item prop="tabTitle" label="绑定指标">
                    <el-select v-model="form.tabTitle" multiple collapse-tags clearable style="width:280px;"
                        placeholder="请选择指标">
                        <el-option
                            v-for="item in tabTitles"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item  label="区县审核人">
                    <el-button @click="getMoreUser()">{{form.areaUsersLabel}}</el-button>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框 -->
        <div v-if="transferVisible">
            <userTransfer ref="userTransfer"></userTransfer>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http'; 
    import userTransfer from '../../sys/user/UserTransfer.vue';

    export default {
        data(){
            return{
                visible: false,
                transferVisible:false,
                form:{
                    id:"",
                    deptId:"",
                    schoolId:"",
                    tabTitle:[],
                    areaUsers:[],
                    areaUsersLabel: "",
                },
                rules: {
                    schoolId: [
                        { required: true, message: '请选择关联上级区县', trigger: 'blur' }
                    ],
                    tabTitle: [
                        { required: true, message: '请选择指标', trigger: 'blur' }
                    ],
                },
                depts:[],
                tabTitles:[]
            }
        },
        components: {
            userTransfer
        },
        created:function () {
        },
        methods:{
            init(data){
                this.visible=true;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.id=data.id;
                this.form.deptId=data.deptId; 

                // 学区教职
                if(data.areaUsers!=null){
                    this.form.areaUsers=data.areaUsers.split(',');
                    this.form.areaUsersLabel=data.areaUsers.split(',').length+"人";
                }else{
                    this.form.areaUsers=[];
                    this.form.areaUsersLabel='请选择';
                }

                // 关联学校
                if(data.schoolId!=null){
                    this.form.schoolId=data.schoolId;
                }else{
                    this.form.schoolId="";
                }
                // TAB标题
                if(data.tabTitle!=null){
                    this.form.tabTitle=data.tabTitle.split(',');
                }else{
                    this.form.tabTitle=[];
                }

                this.getDeptData();
                // 获取指标列表
                this.getTabTitle();
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getDeptData(){
                //部门管理
                let url  = this.listDeptUrl;
                let data = {parentId:"0"};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.depts=res.data.list;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getTabTitle(){
                let url  = this.tabTitleListtUrl;
                let data = {deptId:this.form.deptId};
                this.apiPost(url,data).then((res) => {
                    if(res.status==200){
                        this.tabTitles=res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){

                        if(this.form.areaUsers.length == 0){
                            this.$commonFn.showTip("区县审核人不可为空",3);
                            return;
                        }
                        let url= this.teacherAssessAreaUserUpdateUrl;
                        let data = {
                            id:this.form.id,
                            deptId:this.form.deptId,
                            schoolId:this.form.schoolId,
                            tabTitle:this.form.tabTitle.join(','),
                            areaUsers:this.form.areaUsers.join(',')
                        };
                        // console.log(JSON.stringify(data));
                        // return;
                        this.apiPost(url, data).then((res) => {
                            if(res.status === 200){
                                this.$commonFn.showTip(res.message,1);
                                this.visible=false;
                                this.$parent.getData();
                            }else{
                                this.$commonFn.showTip(res.message,3);
                            }
                        }, (err) => {
                            console.log(err);
                        });
                    }
               });
            },
            getMoreUser(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){
                        this.transferVisible=true;
                        this.$nextTick(() => {
                            if(this.form.areaUsers.length > 0){
                                this.$refs['userTransfer'].init(2,this.form.areaUsers,2,this.form.schoolId);
                            }else{
                                this.$refs['userTransfer'].init(2,null,2,this.form.schoolId);
                            }
                        })
                    }
                 });
            },
            setUser(key,label){
                this.form.areaUsers = key;
                this.form.areaUsersLabel = key.length+"人";
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 300px;
        display: inline-block;
    }
    .del-dialog-cnt{
        font-size: 16px;
        text-align: center
    }
    .table{
        width: 100%;
        font-size: 14px;
    }
    .red{
        color: #ff0000;
    }
    .mr10{
        margin-right: 10px;
    }
</style>


// WEBPACK FOOTER //
// src/components/page/teacherAssess/basis/UpdateAreaTeacher.vue